import React, { useState } from "react";

import {
  TextField,
  Box,
  Typography,
  Checkbox,
  IconButton,
  Modal,
  Button,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Radio,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import { useDrag } from "react-dnd";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import Menu from "@mui/material/Menu";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

import AddIcon from "@mui/icons-material/Add";

const CustomizeInputField = ({
  id,
  name,
  inputType,
  component,
  label,
  compName,
  isExisting,
  uid,
  handleRemoveItem,
  handleEdit,
  options,
  isMandetory,
  isEdit,
  isRequired,
  handleIsHiddenItem,
  isHidden,
  data,
  mandetoryName,
}) => {
  const [editDialog, setEditDialog] = useState(false);
  const [editDialogMultiSelect, setEditDialogMultiSelect] = useState(false);
  const [editDialogRequired, setEditDialogRequired] = useState(false);
  const [editDialogRequiredOpen, seteditDialogRequiredOpen] = useState(false);
  const[hideOpenModal,setHideOpenModal]=useState(false)
  const[hideEdit,setHideEdit]=useState(false)
  const [closeModalOpen, setCloseModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isHiddenOn, setIsHiddenOn] = useState(isHidden);
  const[onHide,setOnHide]=useState(isHiddenOn)
  const [{ opacity, canDrag }, drag] = useDrag({
    type: component,
    item: {
      id,
      name,
      inputType,
      component,
      label,
      compName,
      isExisting,
      uid,
      options,
      isRequired,
      isEdit,
      isHidden,
    },
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
    }),
    canDrag: () => (isMandetory ? true : true),
  });
  //   return <TextField type={inputType} label={label} fullWidth />;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const removeHandler = () => {
    setCloseModalOpen(true);
  };

  const handleEditModalOpen = () => {
    if (
      (compName === "MultiSelect" ||
        compName === "Option" ||
        compName === "Select") 
    ) {
      setEditDialogMultiSelect(true);
    } else {
      setEditDialog(true);
    }
  };

  const handleEditrequredModal = () => {
  
    if (
      (compName === "MultiSelect" ||
        compName === "Option" ||
        compName === "Select") || 
        compName === "Text"  ||
        compName === "Date" ||
        compName === "File" ||
        compName === "TextArea"||
        compName === "date" ||
        compName === "Email" ||
        compName === "Checkbox"||
        compName === "image" 
    ) {
      
      seteditDialogRequiredOpen(true);
    } else {
      setEditDialogRequired(true);
    }
  };

  // const handleIsHidden = React.useCallback(
  //   (e) => {
  //     setIsHiddenOn(uid,e.target.checked);
  //     handleIsHiddenItem(uid, e.target.checked);
  //   },
  //   [isHiddenOn]
  // );

  const  handleIsHidden=(e)=>{
    if (
      (compName === "MultiSelect" ||
        compName === "Option" ||
        compName === "Select") || 
        compName === "Text"  ||
        compName === "Date" ||
        compName === "File" ||
        compName === "TextArea"||
        compName === "date" ||
        compName === "Email" ||
        compName === "Checkbox"||
        compName === "image" 
    ) {
      
      setHideOpenModal(true);
    } else {
      setHideEdit(true);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#ccc",
        padding: "0.5rem",
        borderRadius: "0.25rem",
        opacity,
        borderLeft: isRequired ? "2px solid red" : "2px solid transparent",
      }}
      ref={drag}
    >
      <Typography variant="h6">{label}</Typography>
     
      {(compName === "Text" || compName === "Email") && (
        <TextField
          size="small"
          disabled
          label={compName}
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
        />
      )}

      {compName === "TextArea" && (
        <TextField
          size="small"
          disabled
          label={compName}
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
          multiline={true}
          rows={3}
        />
      )}

      {compName === "Checkbox" && (
        <Checkbox
          disabled
          sx={{
            marginRight: "auto",
            marginLeft: "5%",
          }}
        />
      )}

      {compName === "MultiSelect" && (
        <TextField
          select
          label={compName}
          InputLabelProps={{ shrink: false }}
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
          size="small"
          disabled
        >
          <MenuItem>Option 1</MenuItem>
          <MenuItem>Option 2</MenuItem>
        </TextField>
      )}

      {compName === "File" && (
        <TextField
          size="small"
          disabled
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
          type="file"
        />
      )}

      {compName === "Option" && (
        <FormControl
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
        >
          <RadioGroup row>
            {options.map((option, index) => {
              return (
                <FormControlLabel
                  value={option}
                  control={<Radio />}
                  label={option}
                  disabled
                  key={index}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      )}

      {compName === "Select" && (
        <Autocomplete
          sx={{
            width: "60%",
            marginLeft: "auto",
          }}
          fullWidth
          size="small"
          id={name}
          options={options}
          renderInput={(params) => <TextField {...params} label={compName} />}
          disabled
        />
      )}
      <div style={{display:"flex",justifyContent:"flex-end"}}>
      {isHidden === true?
      <IconButton size="small">
        <VisibilityOffIcon/>
        </IconButton>:<IconButton size="small">
          <VisibilityIcon/>
          </IconButton>}
      </div>
      

      <IconButton
        onClick={handleClick}
      // id="basic-button"
      // aria-controls={open ? "basic-menu" : undefined}
      // aria-haspopup="true"
      // aria-expanded={open ? "true" : undefined}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        // id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleEditModalOpen} >Edit Properties</MenuItem>
        <MenuItem onClick={handleEditrequredModal} disabled={isEdit === false?true:false}>Mark As Required</MenuItem>
        <MenuItem
          onClick={removeHandler}
          sx={{
            color: "red",
          }}
          disabled={isMandetory}
        >
          Remove Field
        </MenuItem>
        <MenuItem  onClick={handleIsHidden} disabled={isEdit === false?true:false}>
        
          {/* <Checkbox
            disabled={isEdit === false?true:false}
            size="small"
            sx={{ padding: "0", marginRight: "0.5rem" }}
            checked={isHiddenOn}
            onChange={(e)=>setIsHiddenOn(e.target.checked)}
          />{" "} */}
          Is Hidden
        </MenuItem>
      </Menu>
      <CloseModal
        open={closeModalOpen}
        setOpen={setCloseModalOpen}
        handleRemoveItem={handleRemoveItem}
        uid={uid}
        handleClose={handleClose}
        label={label}
      />
      <EditDialog
        open={editDialog}
        setOpen={setEditDialog}
        label={label}
        uid={uid}
        handleEdit={handleEdit}
        data={data}
      />
      <EditeIsReured
        open={editDialogRequiredOpen}
        setOpen={seteditDialogRequiredOpen}
        uid={uid}
        isRequired={isRequired}
        handleEdit={handleEdit}
        handleClose={handleClose}
      />
      <HideModal
      open={hideOpenModal}
      setOpen={setHideOpenModal}
      uid={uid}
      isHidden={isHidden}
      handleEdit={handleEdit}
      handleClose={handleClose}
      />


      <EditDialogForMultiSelect
        open={editDialogMultiSelect}
        setOpen={setEditDialogMultiSelect}
        label={label}
        uid={uid}
        handleEdit={handleEdit}
        options={options}
        data={data}
      />
    </Box>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CloseModal({
  open,
  setOpen,
  handleRemoveItem,
  uid,
  handleClose,
  label,
}) {
  // const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Remove {label}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }} variant="h6">
          Are you Sure You Want To Remove It?
        </Typography>
        <Box
          sx={{
            marginTop: "1rem",
            ".MuiButton-root": {
              margin: "0 8px",
            },
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              setOpen(false);
              handleRemoveItem(uid);
              handleClose();
            }}
            sx={{
              background: "crimson",
              "&:hover": {
                background: "red",
              },
            }}
          >
            Yes, Remove The Field
          </Button>
          <Button variant="contained" onClick={() => setOpen(false)}>
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

function EditDialog({ open, setOpen, label, uid, handleEdit ,data}) {
  const [input, setInput] = useState(label);
  const theme = useTheme();
  const handleClose = () => {
    setOpen(false);
  };
  const editHandler = () => {
    if(input ===""){
      alert("Label Can not be Empty ")
      return false
    }
    handleEdit(uid, input, null,null,data.sectionPath);
    handleClose();
  };

  React.useEffect(() => {
    setInput(label);
  }, [label]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          width: "90vw",
          maxWidth: "340px",
        }}
      >
        Edit Properties
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Label
        </DialogContentText>
        <TextField
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "crimson",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Cancel
        </Button>
        <Button onClick={editHandler} autoFocus variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function EditeIsReured({ open, setOpen, uid, isRequired, handleEdit }) {
  const [input, setInput] = useState(isRequired);
  const theme = useTheme();
  console.log(input,"dfjqfgeqrgfe")

  const handleClose = () => {
    setOpen(false);
  };
  const editHandler = () => {
    if(input ===""){
      alert("Label Can not be Empty")
      return false
    }
    handleEdit(uid, null, null,input,null,null);
    handleClose();
  };

  React.useEffect(() => {
    setInput(isRequired);
  }, [isRequired]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          width: "90vw",
          maxWidth: "340px",
        }}
      >
        Edit Properties
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            // display: "flex",
            // alignItems: "center",
            justifyContent: "space-between",
          }}
        >
         
        </DialogContentText>
        <span> Required</span>
        <Checkbox
          size="small"
          //value={input}
          onChange={(e) => setInput(e.target.checked)}
          checked={input}

        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "crimson",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Cancel
        </Button>
        <Button onClick={editHandler} autoFocus variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function HideModal({ open, setOpen, uid, isHidden, handleEdit,isRequired }) {
  const [input, setInput] = useState(isHidden);
  const theme = useTheme();
  console.log(input,"dfjqfgeqrgfe")

  const handleClose = () => {
    setOpen(false);
  };
  const editHandler = () => {
    handleEdit(uid, null, null,isRequired,null,input);
    handleClose();
  };

  React.useEffect(() => {
    setInput(isHidden);
  }, [isHidden]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          width: "90vw",
          maxWidth: "340px",
        }}
      >
        Edit Properties
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            // display: "flex",
            // alignItems: "center",
            justifyContent: "space-between",
          }}
        >
         
        </DialogContentText>
        <span> IsHidden</span>
        <Checkbox
          size="small"
          //value={input}
          onChange={(e) => setInput(e.target.checked)}
          checked={input}

        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "crimson",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Cancel
        </Button>
        <Button onClick={editHandler} autoFocus variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}


function EditDialogForMultiSelect({
  open,
  setOpen,
  label,
  uid,
  handleEdit,
  options,
  data
}) {
  const [input, setInput] = useState(label);
  const theme = useTheme();
  const [optionsArr, setOptionsArr] = useState(options ? options : []);
  const [optionInput, setOptionInput] = useState("");

  const handleClose = () => {
    setOpen(false);
  };
  const editHandler = () => {
    if(input ===""){
      alert("Label Can not be Empty")
      return false
    }
    handleEdit(uid, input, optionsArr,null,data.sectionPath);
    handleClose();
  };

  const handleAddOption = () => {
    if (optionInput.trim() !== "" && !optionsArr.includes(optionInput)) {
      const optionsToSet = [...optionsArr];
      optionsToSet.push(optionInput);
      setOptionInput("");
      setOptionsArr(optionsToSet);
    } else if (optionInput.trim() === "") {
      alert("Options Can not be Empty");
    } else if (optionsArr.includes(optionInput)) {
      alert("Options Should be unique");
    }
  };

  const deleteHandler = (index,option) => {
    console.log(option,"dataggg")
    if (optionsArr.length > 2) {
      const optionsArrToSet = [...optionsArr];
      optionsArrToSet.splice(index, 1);
      setOptionsArr(optionsArrToSet);
    }
    // else if((option == "Other" || option ==  "Client Not Available" ||  option == "Submit without info")){
    //   alert("ll")
    //  return false

    // }
    
    else {
      alert("Minimum 2 Options are required");
    }
  };
  React.useEffect(() => {
    setInput(label);
    setOptionsArr(options ? options : []);
  }, [label, options]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        sx={{
          width: "90vw",
          maxWidth: "340px",
        }}
        id="responsive-dialog-title"
      >
        Edit Properties
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Label
        </DialogContentText>
        <TextField
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          fullWidth
        />
        {/* options */}
        <DialogContentText
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "1.25rem 0 0.5rem 0",
          }}
        >
          Options
        </DialogContentText>
        <TextField
          size="small"
          placeholder="Add Options"
          value={optionInput}
          onChange={(e) => setOptionInput(e.target.value)}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={handleAddOption}>
                  <AddIcon fontSize="large" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box>
          <List>
            {optionsArr?.map((option, index) => {
              return (
                <ListItem
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        deleteHandler(index,option);
                      }}
                    >{option === "Other" || option ===  "Client Not Available" ||  option === "Submit without info" ?"":
                      <DeleteIcon />}
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Typography variant="h6">{index + 1}</Typography>
                  </ListItemAvatar>
                  <ListItemText
                    primary={option}
                  // secondary={secondary ? 'Secondary text' : null}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "crimson",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Cancel
        </Button>
        <Button onClick={editHandler} autoFocus variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomizeInputField;
